import { FC, useState, useEffect } from "react";
import { Controller } from "react-hook-form";
import { Select } from "antd";

const { Option } = Select;

const SelectControl = ({
  name,
  control,
  options,
  defaultValue = "",
  multiple = false,
  errMsg,
  isDisabled = false,
  placeholder = "",
  className = "",
}) => {
  const [optionList, setOptionList] = useState([]);

  useEffect(() => {
    setOptionList(options);
  }, [options]);

  return (
    <div className="my-select-container">
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Select
            {...field}
            defaultValue={defaultValue}
            mode={multiple ? "multiple" : undefined}
            disabled={isDisabled}
            className={`py-2 w-100 rounded ${className}`}
            status={errMsg && "error"}
            size="large"
            allowClear={false}
            bordered
          >
            <Option value="">
              <span className="text-gray-400 text-sm">{placeholder}</span>
            </Option>
            {optionList.length > 0 && (
              <>
                {optionList?.map((item, index) => (
                  <Option key={index} value={item?.value}>
                    {item?.label}
                  </Option>
                ))}
              </>
            )}
          </Select>
        )}
      />
      <p className="text-danger">{errMsg}</p>
    </div>
  );
};

export default SelectControl;
